import { css } from '@adornis/chemistry/directives/css.js';
import { FormField } from '@adornis/formfield/form-field.js';
import { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import '@chancenwerk/design/components/cr-checkbox.js';
import '@chancenwerk/design/components/cr-flex.js';
import '@chancenwerk/design/components/fonts.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * @customElement anmeldung-component-formfield-consent-picture
 */
@customElement('anmeldung-component-formfield-consent-picture')
export class AnmeldungComponentFormfieldConsentPicture extends FormField<boolean> {
  @property({ attribute: false }) public translation = new TranslationController(this);

  override render() {
    return html`
      <cr-flex space="md">
        <cr-text ${css({ padding: `0 ${this.spacing.sm}` })}>
          <i>
            Wir wollen Ihr Kind gut unterstützen und es soll sich bei uns wohlfühlen. Deshalb überprüfen wir unsere
            Arbeit und unser Konzept regelmäßig. Dazu befragen wir die Schüler:innen und Sie. Die Befragung erfolgt ohne
            Nennung von Namen.
          </i>
        </cr-text>

        <cr-flex
          crossaxis-center
          ${css({
            borderRadius: '0 60px',
            overflow: 'hidden',
            border: `${this.spacing.xxs} solid ${this.colors.tone.error}`,
            background: this.colors.tone.error,
          })}
        >
          <cr-h3
            ${css({
              color: this.colors.white,
              padding: this.spacing.md,
            })}
          >
            ${this.translation.translate('consentDeclaration')}
          </cr-h3>
          <cr-flex
            space="md"
            padding="md"
            ${css({
              borderRadius: `0 ${this.spacing.xs}`,
              overflow: 'hidden',
              background: '#F4E2DF',
            })}
          >
            <cr-text
              ${css({
                opacity: '.87',
              })}
            >
              <!-- <b>Verwendungszweck</b><br />
              Aufnahmen innerhalb der Lernförderung und im Rahmen von Aktivitäten: Interne Berichterstattung in unsere
              Vereinsgremien (Mitgliederversammlung, Wissenschaftsbeirat, Wirtschaftsbeirat, Vorstand). Aufnahmen im
              Rahmen von Aktivitäten zusätzlich: Veröffentlichung (z.B. in sozialen Medien), Vervielfältigung (z.B.
              durch den Druck von Flyern) und Verbreitung (z.B. durch das Verteilen eben genannter Flyer) in folgenden
              Medien: Nachrichtenagenturen (z.B. Deutsche Presseagentur), Printmedien (z.B. Tageszeitungen), Online- und
              TV-Medien, sozialen Medien (z.B. Instagram und Facebook), Webpräsenz von Chancenwerk e.V.,
              Öffentlichkeitsarbeit von Chancenwerk e.V. (z.B. Newsletter, Flyer, Jahresbericht). Dabei ist die
              Veröffentlichung, Vervielfältigung und Verbreitung in den oben genannten Medien räumlich, inhaltlich und
              zeitlich unbeschränkt. Bei der Anfertigung von Bildern achten wir darauf, dass keine entstellenden Fotos
              veröffentlicht werden. <br />
              <br />
              <b>Weitergabe an Dritte </b><br />
              Chancenwerk e.V. schließt die Verwendung der Fotos und Videos für Werbezwecke von Konsumartikeln (z.B.
              Bücher, Spiele) oder die Weitergabe an Dritte, sofern es sich nicht um sog. „Pressefotos“ als
              Illustrationsangebot für Medien handelt, ausdrücklich aus. Die Fotos und Videos dienen ausschließlich dem
              Ziel, Publikumsmedien, wissenschaftliche Medien und die allgemeine Öffentlichkeit über das Projekt zu
              informieren. <br />
              <br />
              <b>Löschbarkeit </b><br />
              Informationen im Internet sind weltweit zugänglich und können mit Suchmaschinen gefunden und mit anderen
              Informationen verknüpft werden, woraus sich unter Umständen Persönlichkeitsprofile über den Betroffenen
              erstellen lassen. Ins Internet gestellte Informationen, einschließlich Fotos und Videos, können problemlos
              kopiert und weiterverbreitet werden. Es gibt spezialisierte Archivierungsdienste, deren Ziel es ist, den
              Zustand bestimmter Websites zu bestimmten Terminen dauerhaft zu dokumentieren. Dies kann dazu führen, dass
              im Internet veröffentlichte Informationen auch nach ihrer Löschung auf der Ursprungs-Seite weiterhin
              andernorts aufzufinden sind. Soweit Foto- oder Videoaufnahmen in Social Media-Plattformen verwendet
              werden, geschieht das auf IT-Infrastruktur des Social Media-Plattformbetreibers, für die entsprechende
              Datenschutzbestimmungen des Plattformbetreibers gelten. Chancenwerk e.V. hat darauf nur eingeschränkten
              Einfluss. <br />
              <br />
              <b>Widerruf</b><br />
              Die Einwilligung in die Anfertigung von Foto- und Videoaufnahmen ist freiwillig und kann jederzeit
              widerrufen werden. Es ergeben sich für Sie keine Konsequenzen aus der Verweigerung der Einwilligung oder
              deren Widerruf. Soweit Sie in die Anfertigung von Foto- und Videoaufnahmen nicht einwilligen oder Ihre
              Einwilligung widerrufen, wird Chancenwerk e.V. keine Foto- und Videoaufnahmen mehr von Ihrem Kind
              anfertigen. Im Falle eines Widerrufs ist trotz der Löschung auf den Internetseiten von Chancenwerk e.V.
              oder in Social Media-Plattformen nicht auszuschließen, dass die betroffenen Foto- oder Videoaufnahmen z.B.
              durch die Archivfunktion von Suchmaschinen weiterhin zugänglich sind. <br />
              <br />
              <b>Erklärung</b> <br />
              Die abgebildete Person und, bei Minderjährigen, alle Erziehungsberechtigten erklären ihr Einverständnis
              mit der unentgeltlichen Verwendung der Aufnahmen der oben genannten Person für die auf dieser Seite
              beschriebenen Zwecke. -->
            </cr-text>
          </cr-flex>
          <!-- <cr-flex horizontal crossaxis-center space="md" padding="md" ${css({ position: 'relative' })}>
            <cr-h4 ${css({ position: 'absolute', right: '100%', color: this.colors.white })}>
              Akzeptieren
            </cr-h4>
            <cr-checkbox
              .value=${this.value.value}
              @click=${() => {
            this.value.next(true);
            const eventDis = new CustomEvent('value-picked', {
              detail: {
                value: true,
              },
            });
            this.dispatchEvent(eventDis);
          }}
            ></cr-checkbox>
            <cr-checkbox
              .value=${this.value.value === false}
              @click=${() => {
            this.value.next(false);
            const eventDis = new CustomEvent('value-picked', {
              detail: {
                value: false,
              },
            });
            this.dispatchEvent(eventDis);
          }}
            ></cr-checkbox>
            <cr-h4 ${css({ position: 'absolute', left: '100%', color: this.colors.white })}> Ablehnen </cr-h4>
          </cr-flex> -->
        </cr-flex>
      </cr-flex>
    `;
  }
}
